<template>
    <div>
        <pixi-renderer :width="width" :height="height" ref="renderer">
            <container :x="0" :y="0">
                <sprite :x="0" :y="0" value="/assets/images/card.png"/>
                <qrcode :x="85" :y="345" :size="480" :value="qrcode"></qrcode>
                <pixi-text :x="320" :y="88" :value="name_white" :anchor=".5" fill="#ffffff" :fontSize="56"/>
                <pixi-text :x="320" :y="88" :value="name_first_letter" :anchor=".5" fill="#990000" :fontSize="56"/>
            </container>
        </pixi-renderer>
    </div>
</template>

<script>
    import PixiRenderer from './PIXI/Renderer.vue'
    import Container from './PIXI/Container.vue'
    import Sprite from './PIXI/Sprite.vue'
    import Qrcode from './PIXI/QRcode.vue'
    import PixiText from './PIXI/Text.vue'

    export default {
        components: {
            PixiRenderer,
            Container,
            Sprite,
            Qrcode,
            PixiText,
        },

        props: [
            'qrcode',
            'name',
        ],

        data() {
            return {
                width: 640,
                height: 1493,
                name_white: this.name.replace(/^[^\x01-\x7E\xA1-\xDF]/g, '　').replace(/^[\x01-\x7E\xA1-\xDF]/g, '  '),
                name_first_letter: this.name.replace(/(?!^)[^\x01-\x7E\xA1-\xDF]/g, '　').replace(/(?!^)[\x01-\x7E\xA1-\xDF]/g, '  '),
            }
        },

        methods: {
            download() {
                this.$refs.renderer.download();
            },

            print() {
                this.$refs.renderer.print();
            },
        }
    }
</script>
